import * as React from 'react';
import type { ResolveThunks } from 'react-redux';
import { connect } from 'react-redux';
import { compose } from 'redux';
import type { InjectedFormProps } from 'redux-form';
import { reduxForm, Field } from 'redux-form';

import type { LaborSettingsRM } from 'ab-requestModels/employee.requestModel';

import type { RootState } from 'af-reducers';

import LaborSettings, { LaborSettingsHint } from 'ab-enums/laborSettings.enum';

import { LABOR_SETTINGS } from 'af-constants/reduxForms';

import { Button } from '@acceligentllc/storybook';

import Checkbox from 'af-fields/Checkbox';

import CustomModal from 'af-components/CustomModal';
import SubmitButton from 'af-components/SubmitButton';

import * as CompanyActions from 'af-actions/companies';

interface OwnProps {
	isVisible: boolean;
	toggleEdit: () => void;
}

interface StateProps {
	initialValues: FormProps['initialValues'];
}

interface DispatchProps {
	editLaborSettings: typeof CompanyActions.editLaborSettings;
}

type FormOwnProps = OwnProps & StateProps & ResolveThunks<DispatchProps>;

type FormProps = InjectedFormProps<LaborSettingsRM, FormOwnProps>;

type Props = FormOwnProps & FormProps;

class EmployeeStatusSettingsEdit extends React.PureComponent<Props> {

	editLaborSettings = async (form: LaborSettingsRM) => {
		const { toggleEdit, editLaborSettings } = this.props;
		await editLaborSettings(form);
		toggleEdit();
	};

	render() {
		const { isVisible, toggleEdit, handleSubmit, invalid, submitting } = this.props;

		return (
			<CustomModal
				closeModal={toggleEdit}
				modalStyle="info"
				showModal={isVisible}
				size="lg"
			>
				<CustomModal.Header
					closeModal={toggleEdit}
					title="Edit Labor Settings"
				/>
				<CustomModal.Body className="modal-body--non-padded">
					<Field
						component={Checkbox}
						id="isEmployeeAutomaticReturnDate"
						label={LaborSettings.isEmployeeAutomaticReturnDate}
						name="isEmployeeAutomaticReturnDate"
						tooltipMessage={LaborSettingsHint.isEmployeeAutomaticReturnDate}
					/>
				</CustomModal.Body>
				<CustomModal.Footer>
					<Button
						label="Cancel"
						onClick={toggleEdit}
						style="secondary"
					/>
					<SubmitButton
						disabled={invalid}
						label="Save"
						onClick={handleSubmit(this.editLaborSettings)}
						reduxFormSubmitting={submitting}
					/>
				</CustomModal.Footer>
			</CustomModal>
		);
	}
}

function mapDispatchToProps(): DispatchProps {
	return {
		editLaborSettings: CompanyActions.editLaborSettings,
	};
}

function mapStateToProps(state: RootState): StateProps {
	const { company } = state.company;

	return {
		initialValues: { isEmployeeAutomaticReturnDate: company?.isEmployeeAutomaticReturnDate ?? false } as LaborSettingsRM,
	};
}

const enhance = compose<React.ComponentClass<OwnProps>>(
	connect<StateProps, DispatchProps>(mapStateToProps, mapDispatchToProps()),
	reduxForm<LaborSettingsRM, FormOwnProps>({ form: LABOR_SETTINGS, enableReinitialize: true })
);

export default enhance(EmployeeStatusSettingsEdit);
